
'use client';

import Script from 'next/script';
import { Inter } from 'next/font/google';
import './globals.css';

const inter = Inter({
  subsets: ['latin'],
  variable: '--font-inter',
});
import { Toaster } from '@/components/ui/toaster';
import { AppProvider } from '@/context/app-provider';
import { SidebarProvider } from '@/components/ui/sidebar';
import { LogProvider } from '@/context/log-provider';
import { AuthProvider } from '@/context/auth-provider';
import { ActiveProjectProvider } from '@/context/active-project-context';
import { ChatPanelProvider } from '@/context/chat-panel-context';
import { CharacterContextPanelProvider } from '@/context/character-context-panel-context';
import { GlobalHeader } from '@/components/layout/global-header';

export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return (
    <html lang="en" className={inter.className} suppressHydrationWarning>
      <head>
        <title>StoryStudio</title>
        <meta name="description" content="An agent-based creative writing system" />
        {/* Define isSpace function globally to fix markdown-it issues with Next.js + Turbopack */}
        <Script id="markdown-it-fix" strategy="beforeInteractive">
          {`
            if (typeof window !== 'undefined' && typeof window.isSpace === 'undefined') {
              window.isSpace = function(code) {
                return code === 0x20 || code === 0x09 || code === 0x0A || code === 0x0B || code === 0x0C || code === 0x0D;
              };
            }
          `}
        </Script>
      </head>
      <body className="antialiased font-body bg-background">
        <AuthProvider>
          <ActiveProjectProvider>
            <ChatPanelProvider>
             <CharacterContextPanelProvider>
              <AppProvider>
                <LogProvider>
                  <SidebarProvider>
                    <div className="relative flex min-h-screen flex-col w-full">
                        <GlobalHeader />
                        <div className="flex-1 flex">
                            {children}
                        </div>
                        <Toaster />
                    </div>
                </SidebarProvider>
                </LogProvider>
              </AppProvider>
             </CharacterContextPanelProvider>
            </ChatPanelProvider>
          </ActiveProjectProvider>
        </AuthProvider>
      </body>
    </html>
  );
}
